import React from "react";
import Logo from "../assets/logo.png"; 

export default function Header() {
  return (
    <div 
      className="flex items-center"
      style={{ justifyContent: "space-between", marginBottom: 20 }}
    >
      <img 
        src={Logo} 
        alt="Future Health Logo" 
        style={{ height: 45, objectFit: "contain" }} 
      />
    </div>
  );
}
